import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesLinkTypesActivateRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-linktypes-activate',
	path: '/secure/admin/IssueLinkingActivate.jspa',
};
